export default __webpack_public_path__ + "static/media/coloured-card.2cb57fb9.jpg";